module.exports = __webpack_public_path__ + "img/Page avantages étudiants.7f34c96.png";